<div class="edit-user-dialog">
  <div class="edit-user-dialog__header">
    <span class="edit-user-dialog__title">Edit User</span>
    <button class="edit-user-dialog__close" (click)="dialogRef.close()">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <div class="edit-user-dialog__content">
    <div class="field field--checkbox">
      <input class="checkbox-input" type="checkbox" id="hasReviewerAccess" [(ngModel)]="user.hasReviewerAccess"
        [ngModelOptions]="{standalone: true}" [disabled]="!data.orgIsSelfServiceReview">
      <label for="hasReviewerAccess" class="checkbox-label">
        Has access to Self-Service Manual Reviews?
      </label>
      <span class="material-symbols-outlined help-icon"
        matTooltip="This is only applicable when the Organization's 'Default Manual Reviewer' is 'Self-Service Manual Review'">
        help_outline
      </span>
    </div>

    <div class="edit-user-section">
      <div class="edit-user-section__title">Default User Markup</div>
      <div class="field field--toggle">
        <label class="toggle-label">Inherit values from Team</label>
        <div class="toggle-switch" [class.toggle-switch--on]="user.defaultUserMarkup.useInheritedValues"
          (click)="user.defaultUserMarkup.useInheritedValues = !user.defaultUserMarkup.useInheritedValues">
          <div class="toggle-switch__thumb"></div>
        </div>
      </div>

      @if (!user.defaultUserMarkup.useInheritedValues) {
      <div class="form-row">
        <div class="field">
          <label class="field__label">Percentage Cost Per Transaction</label>
          <div class="field__input-suffix">
            <input class="field__input" type="number" step="0.01" [(ngModel)]="muTransRatePercent"
              [ngModelOptions]="{standalone: true}" [min]="0">
            <span class="field__suffix">%</span>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label class="field__label">Cost Per Transaction</label>
          <div class="field__input-prefix">
            <span class="field__prefix">$</span>
            <input class="field__input" currencyMask [(ngModel)]="user.defaultUserMarkup.costPerTrans"
              [ngModelOptions]="{standalone: true}" [min]="0">
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label class="field__label">Fixed Additional Monthly Fees Total</label>
          <div class="field__input-prefix">
            <span class="field__prefix">$</span>
            <input class="field__input" currencyMask [(ngModel)]="user.defaultUserMarkup.fixedMonthlyFeeTotal"
              [ngModelOptions]="{standalone: true}" [min]="0">
          </div>
        </div>
      </div>
      }
    </div>

    <div class="edit-user-section">
      <div class="edit-user-section__title">Default User Commission</div>
      <div class="field field--toggle">
        <label class="toggle-label">Inherit value from Team</label>
        <div class="toggle-switch" [class.toggle-switch--on]="user.defaultUserCommission.useInheritedValues"
          (click)="user.defaultUserCommission.useInheritedValues = !user.defaultUserCommission.useInheritedValues">
          <div class="toggle-switch__thumb"></div>
        </div>
      </div>

      @if (!user.defaultUserCommission.useInheritedValues) {
      <div class="form-row">
        <div class="field">
          <label class="field__label">Sales Commission Percent</label>
          <div class="field__input-suffix">
            <input class="field__input" type="number" [(ngModel)]="salesCommissPercent"
              [ngModelOptions]="{standalone: true}" [min]="0">
            <span class="field__suffix">%</span>
          </div>
        </div>
      </div>
      }
    </div>

    <div class="edit-user-section">
      <div class="edit-user-section__title">Default Landing Page</div>
      <div class="field">
        <div class="custom-select" [class.custom-select--open]="redirectDropdownOpen"
          (click)="redirectDropdownOpen = !redirectDropdownOpen">
          <span class="custom-select__value">
            {{redirectPage ? (redirectPage.charAt(0).toUpperCase() + redirectPage.slice(1)) : 'Select page'}}
          </span>
          <span class="material-symbols-outlined custom-select__arrow">expand_more</span>
          @if (redirectDropdownOpen) {
          <div class="custom-select__dropdown">
            @for (page of redirectPages; track page) {
            <div class="custom-select__option"
              (click)="redirectPage = page; redirectDropdownOpen = false; $event.stopPropagation()">
              {{page.charAt(0).toUpperCase() + page.slice(1)}}
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="edit-user-dialog__actions">
    <button class="cancel-button" type="button" (click)="dialogRef.close()">Cancel</button>
    <button class="save-edit-user-button" type="button" (click)="save()">Save</button>
  </div>

  <app-saved-dialog [open]="saveDialogOpen" (closed)="closeSaveDialog()"></app-saved-dialog>
</div>